const en = {
    'permission.table.button.create': 'Create permission',
    'permission.table.filter_by_sku': 'Filter by SKU',
    'permission.table.filter_by_description': 'Filter by Description',
    'permission.table.filter_by_deleted': 'Filter by Deleted',
    'permission.table.filter_by_deleted_deleted': 'Deleted',
    'permission.table.filter_by_deleted_not_deleted': 'Not Deleted',
    'permission.table.filter_by_deleted_all': 'All',
    'permission.table.title': 'Permissions',
    'permission.table.sku': 'SKU',
    'permission.table.description': 'Description',
    'permission.table.actions': 'Actions',
    'permission.table.modal.delete.title': 'Delete',
    'permission.table.modal.delete.done': 'Success',
    'permission.table.modal.delete.phrase': 'Are you sure you want to delete?',
    'permission.table.modal.delete.button.cancel': 'Cancel',
    'permission.table.modal.delete.button.delete': 'Delete',
    'permission.table.modal.restore.title': 'Restore',
    'permission.table.modal.restore.done': 'Success',
    'permission.table.modal.restore.phrase': 'Are you sure you want to restore?',
    'permission.table.modal.restore.button.cancel': 'Cancel',
    'permission.table.modal.restore.button.restore': 'Restore',

    'permission.table.category': 'Category',
    'permission.table.filter_by_category': 'Filter by Category',
    'permission.form.update': 'Update permission',
    'permission.form.create': 'Create permission',
    'permission.form.sku': 'SKU',
    'permission.form.description': 'Description',
    'permission.form.category': 'Category',
    'permission.form.cancel': 'Back',
};

export default en;